<template>
  <div class="bgc  chinese_container">
    <div class="password-reset-container">
      <h3 class="title">找回密码</h3>
      <form class="form-container" @submit.prevent="submitForm">
        <div class="form-row">
          <input type="text" placeholder="hecoos账号/邮箱/手机号" class="form-input" v-model="account">
          <div style="position: relative;">
            <input style="width: 54%;" type="text" placeholder="验证码" class="form-input" v-model="code">
            <button type="button" :disabled="!isAccountValid || isCountingDown" @click="getCode" class="get-code-btn">
              {{ isCountingDown ? `${countdown}s后重试` : "获取验证码" }}
            </button>
          </div>
        </div>
        <div class="form-row">
          <input type="password" placeholder="设置密码" class="form-input" v-model="password">
          <input type="password" placeholder="确认密码" class="form-input" v-model="confirmPassword">
        </div>
        <button type="submit" :disabled="!isButtonEnabled" class="submit-btn">
          提交
        </button>
      </form>
      <p>
        <span @click="jumpTo('/')">回首页</span>丨
        <span @click="jumpTo('/register')">去注册</span>
      </p>
    </div>
  </div>
</template>

<script>
import { getModifyPasswordCaptcha, modifyPassword } from "@/api/api";
import { Message } from "element-ui";

export default {
  data() {
    return {
      account: '',
      code: '',
      password: '',
      confirmPassword: '',
      isCountingDown: false,
      countdown: 60
    };
  },
  computed: {
    isAccountValid() {
      const phoneRegex = /^1[3-9]\d{9}$/;
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return phoneRegex.test(this.account) || emailRegex.test(this.account);
    },
    isButtonEnabled() {
      return (
        this.account &&
        this.code &&
        this.password &&
        this.confirmPassword &&
        this.password === this.confirmPassword
      );
    }
  },
  methods: {
    jumpTo(url){
      this.$router.push(url)
    },
    // 获取验证码
    getCode() {
      let postData = {
        loginName: this.account
      };
      getModifyPasswordCaptcha(postData).then((res) => {
        if (res.code === 200) {
          Message.success(res.message);
          this.startCountdown();
        } else {
          Message.error(res.message);
        }
      });
    },
    // 修改密码提交
    submitForm() {
      let formData = {
        loginName: this.account,
        verifyCode: this.code,
        password: this.password,
        confirmPassword: this.confirmPassword
      }
      modifyPassword(formData).then((res) => {
        // console.log(res)
        if (res.code === 200) {
          Message.success(res.message);
          localStorage.clear();
          setTimeout(() => {
            this.$router.push('/login')
          }, 1000);
        } else {
          Message.error(res.message);
        }
      });
    },
    startCountdown() {
      this.isCountingDown = true;
      let timer = setInterval(() => {
        this.countdown--;
        if (this.countdown === 0) {
          clearInterval(timer);
          this.isCountingDown = false;
          this.countdown = 60;
        }
      }, 1000);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/optimize_adaptation.scss";
.bgc {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: url("https://download.hecoos.com/enlightv/2025-17/88bbd52c2dca3a58360b8aa5ad07d60d.png");
  background-size: cover;
  background-repeat: no - repeat;
}

.password-reset-container {
  // width: 550px;
  background-color: #160f23;
  padding: 30px 50px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);

  p{
    margin-top: 15px;
    width: 100%;
    text-align: center;
    font-size: 18px;
    color: #fff;

    span{
      cursor: pointer;
    }
  }
}

.title {
  font-size: 28px;
  color: white;
  text-align: center;
  margin-bottom: 30px;
}

.form-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-row {
  display: flex;
  justify-content: space-between;
  gap: 15px;
}

.form-input {
  // width: 210px;
  width: 48%;
  flex: 1;
  padding: 15px;
  font-size: 18px;
  border: none;
  border-radius: 6px;
  background-color: #27252d;
  color: #c2c2c2;
}

.get-code-btn {
  position: absolute;
  font-size: 18px;
  top: 0;
  right: 0;
  padding: 15px;
  border: none;
  border-radius: 8px;
  background-color: #27252d;
  color: #c2c2c2;
  cursor: pointer;
}

.get-code-btn:disabled {
  cursor: not-allowed;
}

.submit-btn {
  font-size: 18px;
  padding: 15px;
  border: none;
  border-radius: 8px;
  background-color: white;
  color: #000;
  cursor: pointer;
}

.submit-btn:disabled {
  cursor: not-allowed;
}
</style>
